import { render, staticRenderFns } from "./ConversationsSkeleton.vue?vue&type=template&id=257a256b&scoped=true"
import script from "./ConversationsSkeleton.vue?vue&type=script&lang=js"
export * from "./ConversationsSkeleton.vue?vue&type=script&lang=js"
import style0 from "./ConversationsSkeleton.vue?vue&type=style&index=0&id=257a256b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257a256b",
  null
  
)

export default component.exports